<template @scroll="handleScroll">
  <v-card elevation="0" class="mb-15 pl-0" height="100%" tile >
    <v-card-text style="height: 80%; overflow-y: auto;" >
      <v-timeline align-top dense icon-color="black">
        <v-timeline-item
            v-for="(row, index) in timelineData"
            :key="row.id"
            small
            fill-dot
            :icon="getIconForItem(row.eventType)"
            :icon-color="getColorForItem(row.eventType)"
            :large="row.eventType === 'comment'"
            color="white"
            class="mr-4"
        >
          <v-card :class="row.eventType === 'comment' ? 'pa-4' : 'pa-0' " flat :elevation="row.eventType === 'comment' ? 5 : 0">
            <v-card-title class="pa-0">
                <span v-show="row.username !== ''" class="ml-3 mr-2 name-hover userDisplayName" @click="">
                  {{row.userDisplayName}}
                </span>
              <span v-show="row.username !== ''" class="ml-0 username">
                    @{{ row.username }}
                </span>
              <span v-show="row.username === ''" class="ml-3 system-message" v-html="getMarkedDownText(row.message)">
                </span>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" v-show="row.username !== ''" class="ml-2 date">
                    {{ row.eventTime | getTimeFromDate }}
                </span>
                </template>
                <span>{{ row.eventTime | getTimeFromISO }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" v-show="row.username === ''" class="ml-3 mb-4 date" >
                    {{ row.eventTime | getTimeFromDate }}
                </span>
                </template>
                <span>{{ row.eventTime | getTimeFromISO }}</span>
              </v-tooltip>
              <v-spacer></v-spacer>
              <v-icon v-show="row.userId === userId" @click="">mdi-tag-plus-outline</v-icon>
              <v-icon v-show="row.userId === userId" @click="">mdi-pencil</v-icon>
              <v-icon v-show="row.userId === userId" @click="">mdi-share</v-icon>
            </v-card-title>
            <h4 v-show="row.username !== ''" class="ml-3 user-message" v-html="getMarkedDownText(row.message)"/>
            <li v-for="attachment in row.attachments">
              <v-row dense>
                <v-col cols="11">
                  <a class="cut-text ml-7 mr-4">{{attachment.name}}</a>
                  <template class="ml-4" v-for="tag in attachment.tags">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip v-bind="attrs" v-on="on" class="mr-1 mb-4" small outlined>
                          <span class="cut-text">{{tag.label}}</span>
                          <v-icon class="ml-1 mb-3" size="15" @click="$emit('delete-tag', tag.id, attachment.id)" >mdi-close-circle</v-icon>
                        </v-chip>
                      </template>
                      <span>{{tag.label}}</span>
                    </v-tooltip>
                  </template>
                  <v-icon class="ml-1 mb-4" @click="$emit('add-tag', attachment.id)">mdi-tag-plus-outline</v-icon>
                </v-col>
                <v-col cols="1">
                  <v-menu top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="ml-0 mb-4" v-bind="attrs"
                              v-on="on">mdi-dots-vertical</v-icon>
                    </template>
                    <v-list>
                      <v-list-item @click="$emit('display-details', attachment.id)">
                        <v-icon class="mr-1">mdi-alert-circle-outline</v-icon>
                        <span>Szczegóły pliku</span>
                      </v-list-item>
                      <v-list-item @click="$emit('delete-attachment', attachment.id)">
                        <v-icon class="mr-1">mdi-delete-outline</v-icon>
                        <span>Usuń plik</span>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
            </li>
          </v-card>
          <v-row>
            <v-col>
              <v-btn large v-show="index === timelineData.length - 1" outlined text class="pa-7 mt-7 mr-5 button-show-more elevation-3" @click="$emit('load-more-comments')">
                Pokaż więcej
              </v-btn>
            </v-col>
          </v-row>
        </v-timeline-item>
      </v-timeline>
    </v-card-text>
  </v-card>

</template>

<script>

import moment from "moment";
import {marked} from "marked";

const csIcons = [
  {icon: "mdi-autorenew"},
  {icon: "mdi-close-circle"},
  {icon: "mdi-alert-circle-outline"},
  {icon: "mdi-tag-plus-outline"},
  {icon: "mdi-dots-vertical"},
  {icon: "mdi-pencil"},
  {icon: "mdi-share"},
  {icon: "mdi-account"},
  {icon: "mdi-alert-circle"},
  {icon: "mdi-delete-outline"}
]
export default {
  name: "TcnHistory",
  props: ["userId", "processData"],
  filters: {
    getTimeFromDate(eventTime) {
      return moment(eventTime).fromNow();
    },
    getTimeFromISO(eventTime) {
      const date = moment(eventTime)
      return date.isValid() ? date.utc().format('DD.MM.YYYY HH:mm:ss') : "";
    }
  },
  data() {
    return {
      timelineData: this.$props.processData,
      componentKey: 0,
      dialogDetailsAttachments: false,
      chosenRow: {},
      loggedUser: ''
    };
  },
  mounted() {
  },

  created() {
  },
  methods: {
    handleScroll(e) {
      let scrollBar = e.target;
      console.log(scrollBar.scrollTop);
    },
    getTimeFromDate(time) {
      return moment(time).fromNow();
    },
    getMarkedDownText(text) {
      return marked(text);
    },
    getIconForItem(eventType) {
      let result;
      switch (eventType) {
        case 'comment':
          result = "mdi-account";
          break;
        case 'alert':
          result = "mdi-alert";
          break;
        case 'information':
          result = "mdi-alert-circle";
          break;
        default:
          result = "";
          break;
      }
      return result;
    },
    getColorForItem(eventType) {
      let result;
      switch (eventType) {
        case 'comment':
          result = "black";
          break;
        case 'alert':
          result = "red";
          break;
        case 'information':
          result = "green";
          break;
        default:
          result = "";
          break;
      }
      return result;
    },
    displayDetails(row) {
      this.chosenRow = Object.assign({}, row);
      console.log(this.chosenRow);
      this.dialogDetailsAttachments = true;
      console.log(this.dialogDetailsAttachments);
    },
    getFileFormat(mediaType) {
      let result;
      switch(mediaType) {
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          result = 'Dokument Word';
          break;
        default:
          result = "";
          break;
      }
      return result;
    }
  }
}
</script>

<style scoped>

li {
  list-style-type: none;
}
a {
  text-decoration: underline;
}
v-chip {
  display: inline-block;
  text-decoration: none;
  max-width: 10px;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
  overflow-y: auto;
}

.cut-text {
  display: inline-block;
  max-width: 140px;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}

::v-deep .v-chip__content {
  display: inline-block !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

::v-deep .v-chip__close {
  position: absolute;
  top: 5px;
  right: 0;
  width: 24px;
}

.name-hover:hover {
  text-decoration: underline;
}

.button-show-more {
  left: 35%;
}

.v-timeline::before {
  top: 55px;
  height: calc(100% - 110px)
}

.date {
  color: tertiary;
  font-weight: bold;
  font-size: medium;
  font-family: sans-serif;
}

.userDisplayName {
  cursor: pointer;
  font-weight: bold;
  font-size: medium;
  font-family: sans-serif;
}

.username {
  color: tertiary;
  font-weight: bold;
  font-size: medium;
  font-family: sans-serif;
}

.system-message {
  font-style: italic;
  font-size: medium;
}

.user-message {
  font-weight: normal;
}

</style>
